const moment = require("moment");

function shiftDay(day, delta) {
  return moment(day, "YYYYMMDD").add(delta, "d").format("YYYYMMDD");
}

function isToday(day, now = new Date()) {
  return moment(day, "YYYYMMDD").isSame(moment(now), "day");
}

function weekStart(day, weekStartsOnMonday = true) {
  const date = moment(day, "YYYYMMDD");
  const weekday = date.day(); // 0 Sun .. 6 Sat
  const offset = weekStartsOnMonday ? (weekday + 6) % 7 : weekday;
  return date.clone().subtract(offset, "d").format("YYYYMMDD");
}

function weekDays(day, weekStartsOnMonday = true) {
  const start = weekStart(day, weekStartsOnMonday);
  return Array.from({ length: 7 }, (_, i) => shiftDay(start, i));
}

function shiftWeek(day, deltaWeeks, weekStartsOnMonday = true) {
  return shiftDay(weekStart(day, weekStartsOnMonday), deltaWeeks * 7);
}

/** Consecutive calendar days starting at `startDay` (inclusive). */
function dayWindow(startDay, count) {
  const n = Math.max(0, Math.floor(Number(count) || 0));
  return Array.from({ length: n }, (_, i) => shiftDay(startDay, i));
}

module.exports = { shiftDay, isToday, weekStart, weekDays, shiftWeek, dayWindow };
